export default {
    Login: {
        recover_username: {
            event_category: 'content',
            event_action: 'onsite',
            event_content: 'dart - enter username and password: forgotten username',
        },
        recover_password: {
            event_category: 'content',
            event_action: 'onsite',
            event_content: 'dart - enter username and password: forgotten password',
            funnel_name: 'buyer portal - reset password',
            funnel_step: '1',
            funnel_step_name: 'start - forgotten password',
        },
        login: {
            event_category: 'content',
            event_action: 'button click',
            event_content: 'dart - enter username and password: login',
            funnel_name: 'buyer portal - login',
            funnel_step: '2',
            funnel_step_name: 'click to login',
        },
        enter_username: {
            event_category: 'content',
            event_action: 'text entry',
            event_content:
                'dart - enter username and password: username: text entered',
        },
        enter_password: {
            event_category: 'content',
            event_action: 'text entry',
            event_content:
                'dart - enter username and password: password: text entered',
        },
    },
    recoveruser: {
        recover_username_instruction: {
            event_category: 'content',
            event_action: 'button click',
            event_content: 'dart - forgotten username: ok',
        },
    },
    passwordreset_username: {
        username_entered: {
            event_category: 'content',
            event_action: 'text entry',
            event_content:
                'dart - forgotten password - username: username: text entered',
        },
        cancel: {
            event_category: 'content',
            event_action: 'button click',
            event_content: 'dart - forgotten password - username: cancel',
        },
        next: {
            event_category: 'content',
            event_action: 'button click',
            event_content: 'dart - forgotten password - username: next',
        },
    },
    passwordreset_security: {
        answer_entered: {
            event_category: 'content',
            event_action: 'text entry',
            event_content:
                'dart - forgotten password - recovery questions: answer {0}: text entered',
        },
        cancel: {
            event_category: 'content',
            event_action: 'button click',
            event_content: 'dart - forgotten password - recovery questions: cancel',
        },
        submit: {
            event_category: 'content',
            event_action: 'button click',
            event_content: 'dart - forgotten password - recovery questions: submit',
        },
    },
    passwordreset_new: {
        password_entered: {
            event_category: 'content',
            event_action: 'text entry',
            event_content:
                'dart - forgotten password - reset password: password: text entered',
        },
        password_confirmation_entered: {
            event_category: 'content',
            event_action: 'text entry',
            event_content:
                'dart - forgotten password - reset password: confirm password: text entered',
        },
        cancel: {
            event_category: 'content',
            event_action: 'button click',
            event_content: 'dart - forgotten password - reset password: cancel',
        },
        submit: {
            event_category: 'content',
            event_action: 'button click',
            event_content: 'dart - forgotten password - reset password: submit',
        },
    },
    passwordreset_complete: {
        finish: {
            event_category: 'content',
            event_action: 'button click',
            event_content: 'dart - forgotten password - finish: go to login',
        },
    },
    global: {
        page_error: {
            event_category: 'content',
            event_action: 'error',
            event_content: 'page level: {0}',
        },
        field_error: {
            event_category: 'content',
            event_action: 'error',
            event_content: 'line level: {0}: {1}',
        },
    },
    /* This may be unused, remove when safe */
    page_error: {
        event_category: 'content',
        event_action: 'error',
        event_content: 'page level: {0}',
    },
    field_error: {
        event_category: 'content',
        event_action: 'error',
        event_content: 'line level: {0}: {1}',
    },
    /* end */
};



// WEBPACK FOOTER //
// ./shared/userTracking/pageevents.js